import { render } from "./DemandDetail.vue?vue&type=template&id=6e3bf8f4&scoped=true"
import script from "./DemandDetail.vue?vue&type=script&lang=js"
export * from "./DemandDetail.vue?vue&type=script&lang=js"

import "./DemandDetail.vue?vue&type=style&index=0&id=6e3bf8f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3bf8f4"]])

export default __exports__